import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';

import type {
  UserProductTransaction,
  UserProductTransaction_UserProductTransactionsV1Resource_get as UserProductTransactionInfo,
  UserProductTransactionVariables,
} from 'bundles/payments-common/hooks/__generated__/UserProductTransaction';

const USER_PRODUCT_TRANSACTION_QUERY = gql`
  query UserProductTransaction($id: String!) {
    UserProductTransactionsV1Resource {
      get(id: $id) {
        id
        productId
        productType
        productName
        earnCertificateBy
        productUrl
        refundEligibilityV2 {
          id
          isEligible
        }
        transactions {
          cartId
          paymentProcessor
          refundDeadline
          parentCartItemId
          countryIsoCode
          currencyId
          timestamp
          amount
          taxAmount
          orderId
          refundLikeTransactionMetadata {
            transactionActionType
            cartId
            amount
            taxAmount
            currencyCode
            timestamp
          }
        }
      }
    }
  }
`;

const useUserProductTransaction = (
  userProductTransactionId: string,
  skip?: boolean
): {
  userProductTransaction?: UserProductTransactionInfo;
  loading: boolean;
} => {
  const { data, loading } = useQuery<UserProductTransaction, UserProductTransactionVariables>(
    USER_PRODUCT_TRANSACTION_QUERY,
    {
      variables: {
        id: userProductTransactionId,
      },
      errorPolicy: 'all',
      skip,
    }
  );

  const userProductTransaction = data?.UserProductTransactionsV1Resource?.get ?? undefined;

  return { userProductTransaction, loading };
};

export default useUserProductTransaction;
